import styled from 'styled-components/macro'
import { em, rgba, color } from '../../../utils/styles';

const PasswordFieldButton = styled.button.attrs({
  type: 'button'
})`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  border: 0;
  border-radius: 50%;
  padding: 0;
  width: ${em(32)};
  height: ${em(32)};
  vertical-align: middle;
  line-height: 1;
  color: ${rgba('base', 0.4)};
  transition: all 100ms ease-in-out;
  cursor: pointer;

  &:hover {
    color: ${color('base')};
  }

  &:focus {
    background-color: ${color('base')};
    color: ${color('white')};
  }

  svg {
    width: ${em(20)};
    height: ${em(20)};
  }
`

export default PasswordFieldButton
